import { render, staticRenderFns } from "./FilmCard.vue?vue&type=template&id=4cc20196&scoped=true&"
import script from "./FilmCard.vue?vue&type=script&lang=js&"
export * from "./FilmCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc20196",
  null
  
)

export default component.exports